import React from 'react';
import Layout from '../../../../components/Layout';
import { Container, Row, Column } from '../../../../components/Grid';
import Section from '../../../../components/Section';
import { Link } from 'gatsby';
import Video from '../../../../components/Video';
import Icon from '../../../../components/Icon';

const StoryboardingSuccessfulScreenDebut = () => (
  <Layout
    title="Storyboarding for a Successful Screen Debut"
    className="annual-challenge has-video"
  >
    {/* Intro Title and Video */}
    <Section>
      <Container>
        {/* Breadcrumbs */}
        <ul className="breadcrumbs no-hero">
          <li className="breadcrumb">
            <Link to="/annual-challenge/about-the-challenge">
              Annual Challenge
            </Link>
          </li>
          <li className="breadcrumb">
            <Link to="/annual-challenge/event-gallery-videos">
              Inside the Challenge
            </Link>
          </li>
          <li className="breadcrumb">
            <Link to="/annual-challenge/event-gallery-videos">Videos</Link>
          </li>
          <li className="breadcrumb active">
            Storyboarding for a Successful Screen Debut
          </li>
        </ul>
        <Row>
          <Column size={10} offset={1} className="no-hero">
            <h1 className="page-title">
              Storyboarding for a Successful Screen Debut
            </h1>
            {/* Video Container */}
            <div className="video-container__with-pager">
              <div className="videoWrapper">
                <Video youTubeID="4-JKcSKO8sI" className="youtube"></Video>
                <Link to="../process-this-analyze-that" className="next">
                  <Icon name="arrowrightgray" />
                </Link>
              </div>
            </div>
            <h3>
              This webinar from the Discovery Education 3M Young Scientist
              Challenge introduces students to storyboarding and shows how it
              can help in making a Young Scientist Challenge entry video.
            </h3>
          </Column>
        </Row>
      </Container>
    </Section>
  </Layout>
);

export default StoryboardingSuccessfulScreenDebut;
